import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import Utils from "@/vue/infrastructure/utils/helpers";
import DfStore from "@/vue/domain/store/df-store";
import { CONTAINER_TYPES } from "@/vue/infrastructure/ioc/container-types";
import ServiceInterface from "@/vue/service/service-interface";
import DfCoupon from "@/vue/domain/df-coupon";
import DfUser from "@/vue/domain/user/df-user";


@Component({
  components: {
    DfHeaderMobile: () => Utils.externalComponent2("df-header-mobile"),
    DfStoreCard: () => Utils.externalComponent2("df-store-card"),
    DfCardGame: () => Utils.externalComponent2("df-card-game"),
    DfLoadingMask: () => import(/* webpackChunkName: 'df-loading-mask' */ "@/vue/components/df-loading-mask/df-loading-mask.vue"),
  },
})
export default class DfPageAccountGamesComponents extends Vue {
  @Inject(CONTAINER_TYPES.ServiceInterface)
  private service!: ServiceInterface;
  private busy = false;
  private activeTab: "LoyalGuruCoupon" | "SaviCoupon" = null;
  private saviError = false;
  private cordovaSaviUrl = "";

  get currentStore(): DfStore {
    return this.$store.getters.currentStore;
  }

  get currentUser(): DfUser {
    return this.$store.getters.user;
  }

  get enabledPrivateAreaGames(): boolean {
    return process.env.VUE_APP_LOYAL_GURU_GAMES_ENABLED === "true";
  }

  beforeMount() {
    if (this.currentUser) {
      if (this.enabledPrivateAreaGames) {
        this.getCoupons();
      } else {
        this.goToStorePage(this.currentStore);
      }
    }
  }

  private goToStorePage(store: DfStore) {
    this.$router.push({ name: "store", params: { storeAlias: store.alias } }).catch((err) => err);
  }


  get clubCardNumber(): DfUser {
    return Utils.getPropertyValue(this.currentUser, Utils.PROPERTY_USER_CAMI_CARD_NUMBER, "STRING");
  }

  get checkActionActived(): boolean {
    return this.couponList.findIndex((coupon: DfCoupon) => coupon.checked) > -1;
  }

  get couponList(): Array<DfCoupon> {
    return this.$store.getters.couponList;
  }

  set couponList(couponList: Array<DfCoupon>) {
    this.$store.dispatch("setCouponList", couponList);
  }

  private getCoupons() {
    this.busy = true;
    this.service
      .getVoucherAll({
        status: DfCoupon.STATUS_AVAILABLE,
        storeAlias: this.currentStore.alias,
      })
      .then((coupons: Array<DfCoupon>) => {
        this.couponList = coupons;
        this.busy = false;
      })
      .catch((error: Error) => {
        Utils.defaultApiErrorHandler(error, this, () => {
          this.getCoupons();
        });
        this.busy = false;
      });
  }

  private openMap() {
    window.open(`${Utils.GOOGLE_MAP_URL}${Utils.storeGoogleMapsCoordinates(this.currentStore)}`, "_blank");
  }

}
